import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=e8741cdc&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=e8741cdc&prod&lang=css"
import style1 from "./Products.vue?vue&type=style&index=1&id=e8741cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8741cdc",
  null
  
)

export default component.exports